import { render, staticRenderFns } from "./SpecialitiesIndex.vue?vue&type=template&id=01c2c018"
import script from "./SpecialitiesIndex.vue?vue&type=script&lang=js"
export * from "./SpecialitiesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports